const nextImgIndex = (selectedImageIndex, images, add) => {
  let i = selectedImageIndex + add
  if (i >= images.length) {
    i = 0
  }
  return i
}

const prevImgIndex = (selectedImageIndex, images, deduct) => {
  let i = selectedImageIndex - deduct
  if (i < 0) {
    i = images.length - 1
  }
  return i
}

export default {

  showNav () {
    if (!this.$vuetify.breakpoint.mdAndUp) { return }
    this.showingImageNavigation = true
  },

  hideNav () {
    if (!this.mobile) {
      this.showingImageNavigation = false
    }
  },

  setPreloadImages () {
    this.preloadImg1 = nextImgIndex(this.selectedImageIndex, this.images, 2)
    this.preloadImg2 = nextImgIndex(this.selectedImageIndex, this.images, 3)
  },

  showFull () {
    if (this.homepage) {
      let img = this['previewImage' + this.whichImageShowing]
      let id = img && img.objectInfo && img.objectInfo._id
      this.$nextTick(() => {
        this.$router.push({ path: this.objectLink(img.objectInfo) })
      })
    } else {
      this.showingFullImage = true
      this.setPreloadImages()
    }
  },

  closeFull () {
    this.showingFullImage = false
  },

  autoNextImg () {
    if (!this.$vuetify.breakpoint.mdAndUp || this.showingFullImage) {
      return
    }
    // return
    clearTimeout(this.imageAutoSwitchTimer)
    this.imageAutoSwitchTimer = setTimeout(() => {
      if (!this.showingFullImage) {
        this.nextImg()
        this.autoNextImg()
      }
    }, 5000);
  },

  nextImgPage () {
    let i = this.selectedImageIndex + 4
    if (i >= this.images.length) {
      i = 0
    }
    this.changeImage(this.images[i], i)
  },

  prevImgPage () {
    let i = this.selectedImageIndex - 4
    if (i < 0) {
      i = this.images.length - 1
    }
    this.changeImage(this.images[i], i)
  },

  nextImg () {
    let i = nextImgIndex(this.selectedImageIndex, this.images, 1)
    this.setPreloadImages()
    this.changeImage(this.images[i], i)
  },

  prevImg () {
    let i = prevImgIndex(this.selectedImageIndex, this.images, 1)
    this.changeImage(this.images[i], i)
  },

  stopAuto () {
    clearTimeout(this.imageAutoSwitchTimer)
  },

  startAuto () {
    this.autoNextImg()
  },

  changeImage (image, index) {
    this.selectedImageIndex = index
    if (this.whichImageShowing === 1) {
      this.imageUrl2 = image.image
      this.fullImage2 = image
      this.previewImage2 = image
      this.image1Transparent = true
      this.image2Transparent = false
      this.whichImageShowing = 2
    } else {
      this.whichImageShowing = 1
      this.imageUrl1 = image.image
      this.fullImage1 = image
      this.previewImage1 = image
      this.image1Transparent = false
      this.image2Transparent = true
    }
    let nextIndex = nextImgIndex(this.selectedImageIndex, this.images, 1)
    this.previewSideImage2 = this.images[nextIndex]
    let nextNextIndex = nextImgIndex(nextIndex, this.images, 1)
    this.previewSideImage3 = this.images[nextNextIndex]
    let newLeft = index * -88 + 200
    if (newLeft > 0) {
      newLeft = 0
    }
    let lastThumbnail = this.$refs['thumbnail-ref-' + (this.images.length - 1)]
    if (lastThumbnail && lastThumbnail[0] && lastThumbnail[0].offsetParent && lastThumbnail[0].offsetParent.offsetLeft) {
      let offsetLeft = lastThumbnail[0].offsetParent.offsetLeft - this.imagePreviewThumbnailLeftOffset + (this.homepage ? 270 : 0)
      let viewerWidth = this.$refs['viewer-image'].clientWidth
      if (newLeft * -1 > (offsetLeft - viewerWidth + 88)) {
        newLeft = (offsetLeft - viewerWidth + 88) * -1
      }
    }
    this.imagePreviewThumbnailLeftOffset = newLeft
  }
}
